const OPEN_DOWNLOADS_PANEL_EVENT = 'switch:open-downloads-panel';

/**
 * Opens the downloads popover in the nav bar from anywhere in the app (e.g. a
 * toast action). Dialogs that would obscure the popover listen for the same
 * event and close themselves.
 */
export function openDownloadsPanel() {
  window.dispatchEvent(new Event(OPEN_DOWNLOADS_PANEL_EVENT));
}

/** Subscribes to the open event; returns the unsubscribe for useEffect cleanup. */
export function onOpenDownloadsPanel(handler: () => void) {
  window.addEventListener(OPEN_DOWNLOADS_PANEL_EVENT, handler);
  return () => window.removeEventListener(OPEN_DOWNLOADS_PANEL_EVENT, handler);
}
